import {
  BETJENT_TEAM_HISTORIKK_URL,
  BETJENT_TEAM_URL,
  GET_BYBETJENTER_URL,
  POST_BYBETJENTER_URL,
  PUT_BYBETJENTER_URL,
} from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export const actionType = "BYBETJENTER";
const metaData = { entitet: "Bybetjent", notify: true };

export const BYBETJENTTEAMHISTORIKK = "BYBETJENTTEAMHISTORIKK";

export function getBybetjenter(params) {
  return axiosUtils.GetAllWithParams(GET_BYBETJENTER_URL, params, actionType);
}
export function postBybetjenter(payload) {
  return axiosUtils.Post(POST_BYBETJENTER_URL, payload, actionType, metaData);
}
export function putBybetjenter(payload) {
  const url = PUT_BYBETJENTER_URL(payload.id);
  return axiosUtils.Put(url, payload, actionType, metaData);
}

export function getBetjentTeamHistorikk(betjentId) {
  const url = BETJENT_TEAM_HISTORIKK_URL(betjentId);
  return axiosUtils.GetAll(url, BYBETJENTTEAMHISTORIKK);
}

export function addBetjentToTeam(betjentId, teamId) {
  const url = BETJENT_TEAM_URL(betjentId, teamId);
  return axiosUtils.Post(url);
}

export function deleteBetjentsTeam(betjentId, teamId) {
  const url = BETJENT_TEAM_URL(betjentId, teamId);
  return axiosUtils.Delete(url);
}
